'use client';
import { GeneralContext } from '../../providers/GeneralProvider';
import { useContext } from 'react';

export const useDevice = () => {
  const context = useContext(GeneralContext);

  if (!context) {
    throw new Error('useDevice must be used within a GeneralProvider');
  }

  return context.device;
};
